//=================================================
//    summary: DCP Open Web Window -- Hook
//
//    remarks: 000 Tim 2021/11/04 Create
//             001 Tim 2021/12/23 加入 PaintedMe流程
//================================================
import React, { useState, useEffect, useRef } from 'react'
import cssOpenWebWindow from './OpenWebWindow.module.scss'

import {LoadingMask, GlobalLibs} from 'bc-react-package'

// #region Member Variables
let mblnInitialized = false
// #endregion Member Variables


const COMP_NAME = "OpenWebWindow"

function OpenWebWindow(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [showLoadingMask, setShowLoadingMask] = useState(false)
    const [loadingMaskMessage, setLoadingMaskMessage] = useState("")
    // #endregion Init State

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    
    mrefPaintedMe.current = PaintedMe
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)    
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            
            mblnInitialized = false
        }
    }, [props.WebSiteUrl])


    // #region OnTapHandler
    /*===========================================
    summary: 點選 關閉
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function CloseOnTapHandler()
    {
        console.log(COMP_NAME + ".CloseOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }
        
        let objCallbackData = {
            "Action": "CloseShowOpenWebWindow"
        }
        props.CallbackRef(objCallbackData)
    } // end of CloseOnTapHandler
    // #endregion OnTapHandler

    // #region Other EventHandler
    /*===========================================
    summary: Iframe 讀取完畢
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function IframeOnLoaded()
    {
        console.log(COMP_NAME + ".IframeOnLoaded")

        // Close Loading mask        
        CloseLoadingMask()
    } // end of IframeOnLoaded
    // #endregion Other EventHandler

    // #region LoadingMask and Alert Functions
    /*===========================================
    summary: 開啟 讀取中 效果
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log(COMP_NAME + ".OpenLoadingMask")
        setShowLoadingMask(true)
        setLoadingMaskMessage(LoadingMsg)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 讀取中 效果
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")
        setShowLoadingMask(false)
        setLoadingMaskMessage("")
    } // end of CloseLoadingMask
    // #endregion LoadingMask and Alert Functions

    // #region Other Functions
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2021/12/23 Create
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")

        if (props.WebSiteUrl !== "")
        {
            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_LoadOpenWeb)
        } 
    } // end of PaintedMe
    // #endregion Other Functions

    // #region Get ClassName
    /*===========================================
    summary: 取得 此視窗 內容 的 Cls
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function GetContentCls(IsAssessments) 
    {
        let objCls = cssOpenWebWindow.divContent

        if (IsAssessments)
        {
            objCls = cssOpenWebWindow.divContent4Assessments
        }

        return objCls
    } // end of GetContentCls

    /*===========================================
    summary: 取得 Mask Cls
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function GetMaskCls(IsAssessments) 
    {
        let objCls = cssOpenWebWindow.divMask

        if (IsAssessments)
        {
            objCls = cssOpenWebWindow.divMask4Assessments
        }

        return objCls
    } // end of GetMaskCls
    // #endregion Get ClassName

    // #region Render元件
    /*===========================================
    summary: Close Button 顯示Component  
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function ComponentCloseButton()
    {   
        return(
            <div className={cssOpenWebWindow.btnCloseMain} onClick={() => CloseOnTapHandler()}>
                <div className={cssOpenWebWindow.btnCloseIcon}/>
            </div>
        )
    } // end of ComponentCloseButton
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function RenderContentWrapper(WebSiteUrl, ArgList)
    {
        let strWebUrl = WebSiteUrl + "?" + ArgList

        if (WebSiteUrl !== "")
        {
            return (
                <div className={GetContentCls(props.IsAssessments)}>
                    <iframe title="IframeWebSite" 
                        onLoad={IframeOnLoaded}  
                        className={cssOpenWebWindow.iframeWebSite} 
                        src={strWebUrl}
                        allow="microphone; camera"/>
                </div>
            )
        } 
        else 
        {
            return ""
        }
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <div className={GetMaskCls(props.IsAssessments)}>
                <ComponentCloseButton />

                {RenderContentWrapper(props.WebSiteUrl, props.ArgList)}

                <LoadingMask ShowMask={showLoadingMask} Message={loadingMaskMessage} />
            </div>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default OpenWebWindow